export default {
    lang: {
        name: 'Last played all-time'
    }
}